import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'centerBore',
  title: 'Center Bore',
  type: 'document',
  orderings: [
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (rule: any) => rule.required(),
    }),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare({ title = 'Untitled' }) {
      return {
        title,
        subtitle: 'Center bore',
      }
    },
  },
})